import MenuItem from "@material-ui/core/MenuItem";
import { Component } from "react";

import moment from "moment";
import { connect } from "react-redux";
import {
  addItemsToCart,
  redemptionTransaction,
  validateSubBroker,
  getCartItemsList,
} from "../../../store/actions";
import {
  getBankDetails,
  getRedemptionPaymentDetails,
} from "../../../store/actions/transactions";
import {
  AMOUNT,
  FULL,
  PARTIAL,
  PURCHASE,
  REDEMPTION,
  SUBMIT,
  UNITS,
  YES,
  addToCart,
  singleTransaction,
} from "../../../store/types";
import CustomLoader from "../../forms/Loader";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import Signbutton, { Debtbutton } from "../../forms/button";
import { Input } from "../../forms/input";
import { AddToCartStatusModal } from "../customModal";
import CustomizedSelect from "./customizedSelect";
import { NEW_TRANSACTION_URL } from ".";
import { handleError } from "../../../utils/cart";

class Redemption extends Component {
  constructor(props) {
    super(props);
    const { fundList } = this.props;
    const funds = fundList.reduce((prev, curr) => {
      if (curr.rFlag === YES) {
        const findIndex =
          prev.findIndex((fund) => fund.Fund === curr.Fund) !== -1;
        if (!findIndex) {
          return [
            ...prev,
            { Fund: curr.Fund, FundDesc: curr.FundDesc, scheme: curr.Sch },
          ];
        }
      }
      return prev;
    }, []);

    this.state = {
      funds,
      openDialog: false,
      fund: { value: "" },
      folios: [],
      folio: { value: "" },
      schemes: [],
      scheme: { value: "" },
      bank: { value: "", errorMessage: "" },
      amount: { value: "" },
      redemptionType: PARTIAL,
      redemptionMode: UNITS,
      banks: [],
      display: false,
      PosterOpen: false,
      arnCode: { value: this.props.token },
      radioValue: { value: "" },
    };
  }

  handleFundChange = (value) => {
    // if(!!value && !!value.value && (String(value.value).trim() === "176" || String(value.value).trim() === "103")){
    //   this.setState({
    //     PosterOpen:true
    //   })
    // }
    const fund = !!value ? value.value : "";
    if (!value) {
      this.setState({
        fund: { value: "" },
        folios: [],
        scheme: { value: "" },
        folio: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
        amount: { value: "" },
      });
      return;
    } else if (value.value === this.state.fund.value.value) {
      return;
    } else {
      const folios = this.props.fundList.reduce((prev, curr) => {
        if (curr.rSchFlg === YES && curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
      this.setState({
        fund: { value },
        folios: Array.from(new Set(folios)),
        scheme: { value: "" },
        folio: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
      });
    }
  };
  handleFolioChange = async (value) => {
    const folio = !!value ? value.value : "";
    if (!folio) {
      this.setState({
        folio: { value: "" },
        scheme: { value: "" },
        schemes: [],
        banks: [],
        bank: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
        amount: { value: "" },
      });
    } else if (value.value === this.state.folio.value) {
      return;
    } else {
      const params = {
        Acno: folio,
        Trtype: "",
        Fund: this.state.fund.value.value,
      };
      let schemes = this.schemes(folio);
      schemes = schemes.filter((scheme) => scheme.BalUnits !== 0);
      const response = await this.props.getBankDetails(params);

      if (response) {
        const banks = response.Table1;

        this.setState({
          folio: {
            value,
            isError: !schemes.length,
            errorMessage: !schemes.length
              ? "Redemption in zero balance folios is not allowed"
              : "",
          },
          scheme: { value: "" },
          schemes,
          banks,
          bank: { value: banks.length === 1 ? banks[0] : "" },
          redemptionType: PARTIAL,
          redemptionMode: UNITS,
        });
      }
    }
  };
  closePoster = () => {
    this.setState({
      PosterOpen: false,
    });
  };

  schemes = (folio) => {
    return this.props.fundList.reduce((prev, curr) => {
      if (
        curr.rSchFlg === YES &&
        curr.Fund === this.state.fund.value.value &&
        curr.Acno === folio &&
        !!curr.BalUnits
      ) {
        return [...prev, curr];
      }
      return prev;
    }, []);
  };
  handleSchemeChange = (value) => {
    const scheme = !!value ? value.value : "";
    if (!scheme) {
      this.setState({
        scheme: { value: "" },
        minAmount: "",
        amount: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
      });
    } else if (value.value === this.state.scheme.value.value) {
      return;
    } else {
      this.setState({
        scheme: { value },
        minAmount: !!scheme ? scheme.RedMinAmt || scheme.fm_newpur : "",
        amount: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
      });
    }
  };

  showError = (label) => () => {
    const {
      [label]: { value },
    } = this.state;

    if (label === "amount") {
      const { scheme, redemptionMode, amount } = this.state;

      if (scheme && scheme.value) {
        const schemeValue = scheme.value.value;
        const isAmountValid =
          redemptionMode === AMOUNT
            ? schemeValue.MinAmt > parseInt(amount.value) * (1 + 0.05)
            : schemeValue.BalUnits < amount.value;

        const errorMessage = !amount.value
          ? redemptionMode === AMOUNT
            ? "Amount is mandatory*"
            : "Redemption units is mandatory"
          : redemptionMode === AMOUNT &&
            schemeValue.MinAmt > parseInt(amount.value) * (1 + 0.05)
          ? `Amount should be ${schemeValue.MinAmt}`
          : schemeValue.BalUnits < amount.value
          ? "You don't have enough Units To Redeem!"
          : "";

        this.setState({
          [label]: {
            value,
            isError: isAmountValid || !value,
            errorMessage,
          },
        });
      }
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };
  handleRedemptionValueChange(event) {
    const { redemptionMode, redemptionType } = this.state;
    if (event.target.value.length <= 10) {
      if (redemptionMode === UNITS && redemptionType === PARTIAL) {
        if (
          /^[0-9]*$/.test(event.target.value) ||
          /[-+]?[0-9]*(\.[0-9]{0,3}$)/.test(event.target.value)
        ) {
          this.setState({
            amount: {
              value: event.target.value,
              isError: Number(event.target.value) <= 0 ? true : false,
              errorMessage:
                Number(event.target.value) <= 0
                  ? redemptionMode === AMOUNT
                    ? "Amount is mandatory*"
                    : "Redemption units is mandatory"
                  : "",
            },
          });
        }
      } else {
        this.setState({
          amount: { value: event.target.value.replace(/^0+/, "") },
        });
      }
    }
  }

  changeRedemptionType = (value) => () => {
    if (value === FULL) {
      this.setState({
        redemptionType: FULL,
        redemptionMode: UNITS,
        amount: {
          value: !!this.state.scheme.value
            ? this.state.scheme.value.value.BalUnits
            : "",
        },
      });
    }
    if (value === PARTIAL) {
      this.setState({
        redemptionType: PARTIAL,
        amount: { value: "" },
      });
    }
  };
  changeRedemptionMode = (value) => () => {
    if (value === AMOUNT) {
      this.setState({
        redemptionMode: AMOUNT,
        amount: { value: "" },
      });
    }
    if (value === UNITS) {
      this.setState({
        redemptionMode: UNITS,
      });
    }
  };
  handlefolioBankDetailsChange = (event) => {
    this.setState({
      bank: { value: event.target.value },
    });
  };
  submit = async () => {
    const {
      funds,
      openDialog,
      banks,
      schemes,
      folios,
      redemptionType,
      redemptionMode,
      minAmount,
      PosterOpen,
      display,
      bank,
      radioValue,
      arnCode,
      subArnCode,
      ...others
    } = this.state;
    if (this.state.bank.value === "") {
      this.setState({
        bank: {
          value: "",
          isError: true,
          errorMessage: "(Please select the bank details)",
        },
      });
    }
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage:
                key === "amount"
                  ? redemptionMode === AMOUNT
                    ? "Amount is mandatory*"
                    : "Redemption units is mandatory"
                  : `${key} is mandatory*`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "folio": {
          this.folioField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "amount": {
          this.amountField.focus();
          break;
        }
      }
    } else if (
      this.state.redemptionMode === AMOUNT &&
      this.state.scheme.value.value.MinAmt > parseInt(this.state.amount.value)
    ) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: `(Amount shoud be ${this.state.scheme.value.value.MinAmt} INR)`,
        },
      });
    }
    // else if (
    //   !!currValue &&
    //   !!this.state.amount.value &&
    //   currValue < this.state.amount.value
    // ) {
    //   this.setState({
    //     amount: {
    //       value: "",
    //       isError: true,
    //       errorMessage:
    //         "( Investment amount should not be greater than Current value )"
    //     }
    //   });
    // }
    else if (
      this.state.redemptionMode !== AMOUNT &&
      this.state.scheme.value.value.BalUnits < this.state.amount.value
    ) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: `( You dont have enough points to redeem )`,
        },
      });
    } else if (this.state.bank.value === "") {
      this.setState({
        bank: {
          ...others["bank"],
          isError: true,
          errorMessage: `( Please select the bank  )`,
        },
      });
    } else {
      this.setState({
        display: true,
      });
      const params = {
        amount: redemptionMode === AMOUNT ? others.amount.value : "0",
        Fund: others.fund.value.value,
        plan: others.scheme.value.value.Pln,
        scheme: others.scheme.value.value.Sch,
        acno: others.scheme.value.value.Acno,
        trdt: moment(new Date()).format("MM/DD/YYYY"),
        units: redemptionMode === UNITS ? others.amount.value : "0",
        ttrtype: PURCHASE,
      };
      const response = await this.props.getRedemptionPaymentDetails(params);
      if (response) {
        this.props.history.push({
          pathname:
            NEW_TRANSACTION_URL + "/redemption/digital/transact/confirm",
          state: {
            title: "Redemption Payment Summary",
            type: REDEMPTION,
            scheme: others.scheme.value.value,
            redemptionMode,
            Folio: { value: others.scheme.value.value.Acno },
            redemptionType,
            amount: others.amount.value,
            bank: this.state.bank.value,
          },
        });
      }
      this.setState({
        display: false,
      });
    }
  };

  onButtonClick = async (btnLabel) => {
    try {
      const {
        funds,
        openDialog,
        banks,
        schemes,
        folios,
        redemptionType,
        redemptionMode,
        minAmount,
        PosterOpen,
        display,
        bank,
        radioValue,
        arnCode,
        subArnCode,
        ...others
      } = this.state;
      if (this.state.bank.value === "") {
        this.setState({
          bank: {
            value: "",
            isError: true,
            errorMessage: "(Please select the bank details)",
          },
        });
        return;
      }
      const currValue = this.state?.scheme?.value?.value?.CurValue;
      const keys = Object.keys(others);
      const findError = keys.every((key) => !!others[key].value);
      if (!findError) {
        keys.forEach((key) => {
          !others[key].value &&
            this.setState({
              [key]: {
                ...others[key],
                isError: true,
                errorMessage:
                  key === "amount"
                    ? redemptionMode === AMOUNT
                      ? "Amount is mandatory*"
                      : "Redemption units is mandatory"
                    : `${key} is mandatory*`,
              },
            });
        });
        const firstErroredKey = keys.find((key) => !others[key].value);
        switch (firstErroredKey) {
          case "fund": {
            this.fundField.focus();
            return;
          }
          case "folio": {
            this.folioField.focus();
            return;
          }
          case "scheme": {
            this.schemeField.focus();
            return;
          }

          case "amount": {
            this.amountField.focus();
            return;
          }
          default:
            break;
          // case "bank": {
          //   this.bankField.focus();
          //   break;
          // }
        }
      }
      if (!parseFloat(this.state.amount.value)) {
        this.setState({
          amount: {
            value: "",
            isError: true,
            errorMessage: `Amount should be ${parseFloat(
              this.state.scheme.value.value.MinAmt
            )}`,
          },
        });
        return;
      }
      if (this.state.redemptionMode === AMOUNT) {
        const minimumAmount = parseFloat(
          this.state.scheme.value.value.RedMinAmt
        );
        const availableBalance = parseFloat(currValue.replace(/,/g, ""));
        const enteredAmount = parseFloat(this.state.amount.value);

        if (availableBalance > minimumAmount && enteredAmount < minimumAmount) {
          this.setState({
            amount: {
              value: "",
              isError: true,
              errorMessage: `Amount should be ${minimumAmount}`,
            },
          });
          return;
        }
        if (
          availableBalance < minimumAmount &&
          enteredAmount * (1 + 0.05) < minimumAmount
        ) {
          this.setState({
            amount: {
              value: this.state.amount.value,
              isError: true,
              errorMessage: `You do not have enough amount to redeem`,
            },
          });
          return;
        }

        if (enteredAmount > availableBalance) {
          this.setState({
            amount: {
              value: this.state.amount.value,
              isError: true,
              errorMessage: `You don't have enough amount to redeem`,
            },
          });
          return;
        }
      }

      if (
        this.state.redemptionMode !== AMOUNT &&
        this.state.scheme.value.value.BalUnits < this.state.amount.value
      ) {
        this.setState({
          amount: {
            value: this.state.amount.value,
            isError: true,
            errorMessage: `( You dont have enough units to redeem )`,
          },
        });
      } else if (this.state.bank.value === "") {
        this.setState({
          bank: {
            ...others["bank"],
            isError: true,
            errorMessage: `( Please select the bank  )`,
          },
        });
      } else {
        this.setState({
          display: true,
        });

        const { communicationDetails, investorData } = this.props;
        const Xmobile = communicationDetails.find(
          (detail) =>
            detail.Fund === this.state.fund.value.value &&
            detail.Acno === this.state.folio.value.value &&
            detail.PAN === investorData.PAN &&
            !!detail.Mobile
        );
        const Xemail = communicationDetails.find(
          (detail) =>
            detail.Fund === this.state.fund.value.value &&
            detail.Acno === this.state.folio.value.value &&
            detail.PAN === investorData.PAN &&
            !!detail.email
        );

        const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
        const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";
        const selectedFund = funds.find(
          (i) => i.Fund === others.fund.value.value
        ).FundDesc;

        const params = {
          pan: this.props.investorData.PAN,
          mobile: Mobile,
          email: Email,
          fund: others.fund.value.value,
          scheme: others.scheme.value.value.Sch,
          plan: others.scheme.value.value.Pln,
          option: others.scheme.value.value.Opt,
          amount: redemptionMode === AMOUNT ? others.amount.value : "0",
          units: redemptionMode === UNITS ? others.amount.value : "0",
          arnCode: this.state.arnCode.value,
          partial: redemptionType === PARTIAL ? true : false,
          dcr: singleTransaction.DCR,
          userId: this.props.userId,
          folio: others.scheme.value.value.Acno.toString(),
          ifscCode: this.state.bank.value.ifsccode,
          bankName: this.state.bank.value.bnkname,
          bankAccountNumber: this.state.bank.value.bnkacno,
          bankAccountType: this.state.bank.value.bnkactype,
          transactionType: singleTransaction.REDEMPTION,
          schemeName: this.state.scheme.value.label,
          investorName: investorData.invname,
          taxSaverFlag: others.scheme.value.value.TaxSaverFlag,
          fundName: selectedFund,
        };

        if (btnLabel === SUBMIT) {
          const response = await this.props.redemptionTransaction(params);

          if (response) {
            this.props.history.goBack();
          }
        } else if (btnLabel === addToCart) {
          const response = await this.props.addItemsToCart(params);
          if (response) {
            const [newCartItem] = response.cartItems.sort(
              (item1, item2) =>
                Number(item2.cartItemId) - Number(item1.cartItemId)
            );
            this.setState({
              openDialog: true,
              cartId: response.bulkOrderId,
              ihno: newCartItem.ihno,
            });
          }
        }

        this.setState({
          display: false,
        });
      }
    } catch (error) {
      handleError(error);
    }
  };

  close = () => {
    this.setState({ openDialog: false });
  };

  changeValue = (label) => (event) => {
    if (
      (label === "subArnCode" || label === "subBrokerCode") &&
      event.target.value.length <= 20
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
    if (label === "radioValue" && event.target.value === "no") {
      this.setState({
        radioValue: { value: event.target.value },
      });
    }
    if (label === "radioValue" && event.target.value === "yes") {
      this.setState({
        [label]: { value: event.target.value },
        euinNo: { value: "" },
      });
    } else if (
      label !== "subArnCode" &&
      label !== "subBrokerCode" &&
      label === "radioValue" &&
      event.target.value !== "no"
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  validateBrokerCode = async (fund) => {
    const { subArnCode, arnCode } = this.state;
    if (
      !!this.state.subArnCode.value &&
      this.state.subArnCode.value === this.state.arnCode.value.split("-")[1]
    ) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: "ARN and Sub ARN Code should not be the same",
        },
      });
      return;
    }
    const params = {
      Fund: fund,
      SubAgentCd: !!subArnCode.value ? `ARN-${subArnCode.value}` : "",
      AgentCd: arnCode.value,
    };
    const response = await this.props.validateSubBroker(params);
    if (!!response && !!response.DtData && response.DtData.length > 0) {
      const getLength = response.DtData.length === 1;
      if (!!getLength) {
        this.setState({
          euinNo: { value: response.DtData[0].abm_agent },
        });
      }
    } else if (!response) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `Please enter a valid Sub ARN Code`,
        },
      });
    }
  };

  render() {
    const {
      fund,
      funds = [],
      folio,
      folios = [],
      schemes = [],
      scheme,
      bank,
      banks,
      amount,
      redemptionType,
      redemptionMode,
      radioValue,
      euinNo,
    } = this.state;

    const { euinList } = this.props;
    // console.log("amount:", amount);

    const checkMultiBrokerFlag =
      !!this.state.scheme &&
      !!this.state.scheme.value &&
      !!this.state.scheme.value.value &&
      !!this.state.scheme.value.value.multibrokflg &&
      this.state.scheme.value.value.multibrokflg === "Y";

    return (
      <div className="transaction-details">
        {/* <PosterDialog open={this.state.PosterOpen} close={this.closePoster} /> */}
        <div className="title">Redemption</div>

        <div className="input-margin">
          <div className="input-name input-integrated-label">AMC</div>
          <IntegrationReactSelect
            suggestions={funds.map((item) => ({
              label: item.FundDesc,
              value: item.Fund,
            }))}
            value={fund.value}
            placeholder="Select AMC"
            handleChange={this.handleFundChange}
            inputRef={(ele) => (this.fundField = ele)}
            isError={fund.isError}
            errorMessage={fund.errorMessage}
          />
        </div>

        <div className="input-margin">
          <div className="input-name input-integrated-label">Folio</div>
          <IntegrationReactSelect
            suggestions={folios.map((item) => ({
              label: item,
              value: item,
            }))}
            value={folio.value}
            placeholder="Select Folio"
            handleChange={this.handleFolioChange}
            inputRef={(ele) => (this.folioField = ele)}
            isError={folio.isError}
            disabled={!fund.value}
            errorMessage={folio.errorMessage}
          />
        </div>

        <div className="input-name">
          <div className="input-name input-integrated-label">Scheme</div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
              value: item,
            }))}
            value={scheme.value}
            placeholder="Select Scheme"
            handleChange={this.handleSchemeChange}
            inputRef={(ele) => (this.schemeField = ele)}
            isError={scheme.isError}
            disabled={!folio.value}
            errorMessage={scheme.errorMessage}
          />
        </div>

        <div className="redemption-details">
          <div className="keys">
            {!checkMultiBrokerFlag && <div>Balance Units</div>}
            {!checkMultiBrokerFlag && <div>Current Value</div>}
            <div>NAV as on Date</div>
            <div>Minimum Amount (INR)</div>
          </div>
          <div className="values">
            {!checkMultiBrokerFlag && (
              <div>{!!scheme.value ? scheme.value.value.BalUnits : ""}</div>
            )}
            {!checkMultiBrokerFlag && (
              <div>{!!scheme.value ? scheme.value.value.CurValue : ""}</div>
            )}
            <div>{!!scheme.value ? scheme.value.value.LastNAV : ""}</div>
            <div>{!!scheme.value ? scheme.value.value.RedMinAmt : ""}</div>
          </div>
        </div>

        {!!checkMultiBrokerFlag && (
          <div
            style={{
              fontFamily: "OpenSans-SemiBold",
              fontSize: 13,
              color: "red",
              margin: 10,
            }}
          >
            {" "}
            Note: This folio has multiple distributors. Hence, the balance units
            and current value will not be displayed. In case of full redemption,
            all the units in the investor's portfolio will be redeemed.
          </div>
        )}

        <div className="input-name">Select Redemption Type</div>
        <div className="radio-buttons-div">
          <Debtbutton
            buttontitle="Partial"
            width={150}
            active={redemptionType === PARTIAL}
            onClick={this.changeRedemptionType(PARTIAL)}
            textTransform={"capitalize"}
          />
          <Debtbutton
            buttontitle="Full"
            width={150}
            active={redemptionType === FULL}
            onClick={this.changeRedemptionType(FULL)}
            textTransform={"capitalize"}
          />
        </div>
        {this.state.redemptionType !== FULL ? (
          <>
            <div className="input-name">Select Redemption Mode</div>
            <div className="radio-buttons-div">
              <Debtbutton
                buttontitle="Units"
                width={150}
                active={redemptionMode === UNITS}
                onClick={this.changeRedemptionMode(UNITS)}
                textTransform={"capitalize"}
              />
              <Debtbutton
                buttontitle="Amount"
                width={150}
                disabled={redemptionType === FULL ? true : false}
                active={redemptionMode === AMOUNT}
                onClick={this.changeRedemptionMode(AMOUNT)}
                textTransform={"capitalize"}
              />
            </div>
          </>
        ) : null}

        <div className="input-margin">
          <Input
            name="Redemption Value (INR/UNITS)"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "-") && evt.preventDefault()
            }
            bordercolor="#a6a6a6"
            errorMessage={amount.errorMessage}
            isShowError={amount.isError}
            type="number"
            onBlur={this.showError("amount")}
            disabled={redemptionType === FULL ? true : false}
            inputref={(ele) => (this.amountField = ele)}
            onChange={(event) => this.handleRedemptionValueChange(event)}
            value={amount.value}
          />
        </div>

        <div className="input-margin">
          <CustomizedSelect
            placeholder="Select Bank"
            name="Bank"
            isError={bank.isError}
            errorMessage={bank.errorMessage}
            handleChange={this.handlefolioBankDetailsChange}
            value={bank.value}
            borderColor="#a6a6a6"
            disabled={!folio.value}
            inputRef={(ele) => (this.bankField = ele)}
          >
            {banks.map((item, index) => (
              <MenuItem
                value={item}
                key={index}
                style={{ whiteSpace: "pre-wrap" }}
              >
                {item.bnkname}-{item.bnkacno}
              </MenuItem>
            ))}
          </CustomizedSelect>
          {/* {!!bank.errorMessage ? <div>{bank.errorMessage}</div> : ""} */}
        </div>
        <div className="trantype-button-view">
          <Signbutton
            buttontitle="Add to cart"
            onClick={() => this.onButtonClick(`${addToCart}`)}
            width={240}
            border={"1px solid #007CC5"}
            texttransform={true}
          />
          <span className="addtocart-btn" />
          <Signbutton
            buttontitle="Submit"
            onClick={() => this.onButtonClick(SUBMIT)}
            width={240}
            border={"1px solid #007CC5"}
            texttransform={true}
          />
        </div>

        <AddToCartStatusModal
          message={`Transaction has been added to cart successfully with the reference number ${this.state.ihno} and bulk-order ID ${this.state.cartId}`}
          closeModal={this.close}
          open={this.state.openDialog}
          image={"/images/cart_success.svg"}
          btn_one={"Go to cart"}
          btn_two={"Add more"}
          pan={this.props.investorData.PAN}
          onAddTransaction={() =>
            this.props.history.push("/cart/add-transaction/redemption", {
              pan: this.props.investorData.PAN,
            })
          }
          ihno={this.state.ihno}
          cartId={this.state.cartId}
        />
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      token,
      userId,
      bankDetails,
      investorData,
      communicationDetails,
      isCartUser,
    } = authReducer;
    const { euinList } = transactions;
    return {
      fundList,
      token,
      userId,
      bankDetails,
      investorData,
      communicationDetails,
      euinList,
      isCartUser,
    };
  },
  {
    getBankDetails,
    getRedemptionPaymentDetails,
    redemptionTransaction,
    addItemsToCart,
    validateSubBroker,
    getCartItemsList,
  }
)(Redemption);
